import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const HttpXmlConnectorForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  const isGet = form.watch('properties.httpMethod') === 'GET';

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="httpXmlConnectorFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="httpXmlConnectorFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="httpXmlConnectorFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="httpXmlConnectorFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter parameterization"
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="httpXmlConnectorFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>
      <FormField
        controlId="httpXmlConnectorFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter file format"
        error={errors?.format?.message}
      />
      <FormField
        controlId="httpXmlConnectorFormHttpMethod"
        label="httpMethod"
        name="properties.httpMethod"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        placeholder="Enter HTTP method"
        required
        error={errors?.properties?.httpMethod?.message}
      >
        <option value="">Select HTTP Method</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
      </FormField>
      <FormField
        controlId="httpXmlConnectorFormUrl"
        label="url"
        name="properties.url"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter URL"
        required
        error={errors?.properties?.url?.message}
      />
      <FormField
        controlId="httpXmlConnectorFormHeaders"
        label="headers"
        name="properties.headers"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        placeholder="Enter headers"
        error={errors?.properties?.headers?.message}
        rows={10}
      />
      <FormField
        controlId="httpXmlConnectorFormHeadersJson"
        label="headersJson"
        name="properties.headersJson"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.JSON}
        placeholder="Enter headers in JSON format"
        error={errors?.properties?.headersJson?.message}
        rows={10}
      />
      <FormField
        controlId="httpXmlConnectorFormAcceptInvalidCerts"
        label="acceptInvalidCerts"
        name="properties.acceptInvalidCerts"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      {!isGet && (
        <FormField
          controlId="httpXmlConnectorFormBody"
          label="body"
          name="properties.body"
          control={formControl}
          fieldComponentType={FORM_FIELD_TYPES.JSON}
          placeholder="Enter body"
          error={errors?.properties?.body?.message}
          rows={10}
          disabled={isGet}
        />
      )}
      <FormField
        controlId="httpXmlConnectorFormConvertXmlToJson"
        label="convertXmlToJson"
        name="properties.convertXmlToJson"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="httpXmlConnectorFormConvertJsonToXmlBody"
        label="convertJsonToXmlBody"
        name="properties.convertJsonToXmlBody"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        placeholder="Enter JSON to XML body conversion"
        error={errors?.properties?.convertJsonToXmlBody?.message}
      />
      <FormField
        controlId="httpXmlConnectorFormIncludePropertyAtSymbol"
        label="includePropertyAtSymbol"
        name="properties.includePropertyAtSymbol"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default HttpXmlConnectorForm;
